// extracted by mini-css-extract-plugin
export default {"body":"light_body__Ayepn","text":"light_text__fOjtk","overflow":"light_overflow__m5lrj color_colorDarkBackground__VTGL5","circle":"light_circle__4zRmy"};